import * as React from 'react';
import Modal from "react-responsive-modal";
import Input from '../../../../../common/Input/Input'
import InputUtils, {Type} from "../../../../../../InputUtils";
import Utils from "../../../../../../Utils";
import {AxiosPromise} from "axios";
import '../createUserModal/createUserModalStyles.css'

interface IState {
    validateForm: boolean;
    form: any,
}

interface IProps {
    showInviteUserModal: boolean;
    closeInviteUserModal(): void;
    refreshGrid(): void;
    inviteUserRequest(dto: any): AxiosPromise;
}

class InviteUserModal extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            validateForm: false,
            form: {
                firstName: {
                    value: '',
                    valid: true,
                    errorMsg: 'First name cannot be empty'
                },
                lastName: {
                    value: '',
                    valid: true,
                    errorMsg: 'Last name cannot be empty',
                },
                userName: {
                    value: '',
                    valid: true,
                    errorMsg: 'Username name cannot be empty',
                },
                email: {
                    value: '',
                    valid: true,
                    errorMsg: 'Invalid email address',
                },
            }
        };
    }

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {
        if (this.props.showInviteUserModal && this.props.showInviteUserModal !== prevProps.showInviteUserModal ) {
            document.addEventListener('keydown', this.keydownModalHandler);
        }
        if (this.props.showInviteUserModal !== prevProps.showInviteUserModal && !this.props.showInviteUserModal) {
            document.removeEventListener('keydown', this.keydownModalHandler);
        }
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.keydownModalHandler);
    }

    keydownModalHandler = (e) => {
        if (e.keyCode === 13) {
            Utils.$('#btn-invite').click();
        }
    }

    onChange = (event, id) => {
        const eventValue = event.target.value;

        this.setState({
            form: {
                ...this.state.form,
                [id]: {
                    ...this.state.form[id],
                    value: eventValue,
                    valid: true
                }
            }
        })
    }

    close = () => {
        this.resetForm();
        this.props.closeInviteUserModal();
    }

    resetForm = () => {
        this.setState({
            form: InputUtils.resetForm(this.state.form)
        })
    }

    checkFormValidity = (): boolean => {
        const keys = Object.keys(this.state.form);
        const formCopy = JSON.parse(JSON.stringify(this.state.form));
        let formIsValid = true;
        keys.forEach((key, index) => {
            switch (key) {
                case 'firstName':
                    if (formCopy[key].value === '') {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break
                case 'lastName':
                    if (formCopy[key].value === '') {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break
                case 'userName':
                    if (formCopy[key].value === '') {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break
                case 'email':
                    const str = formCopy[key].value;
                    if (!InputUtils.EMAIL_REGEX.test(str)) {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
            }
        })

        this.setState({
            form: formCopy
        })

        return formIsValid;
    }

    inviteUserHandler = () => {
        if (this.checkFormValidity()) {
            const dto = {
                firstName: this.state.form.firstName.value,
                lastName: this.state.form.lastName.value,
                username: this.state.form.userName.value,
                email: this.state.form.email.value,
            }

            this.props.inviteUserRequest(dto)
                .then(() => {
                    this.props.refreshGrid();
                    this.close();
                })
                .catch((requestError) => {
                    console.error(requestError);
                })
        }
    }

    render() {
        return (
            <Modal
                open={this.props.showInviteUserModal}
                styles={{
                    overlay: {zIndex: 10000},
                    closeButton: {display: "none"},
                    modal: {
                        width: 750,
                        padding: 0,
                        maxWidth: 750,
                    }
                }}
                closeOnEsc={true}
                onClose={this.close}
                center
                focusTrapped={true}
                closeOnOverlayClick={false}
            >
                <div style={{width: '100%', height: '85%', backgroundColor: "#2B2B2B"}}>
                    <div className="row" style={{height: '100%'}}>
                        <div id={'create-user-container'} className='col-lg-12 compare-changes'>
                            <header className={'create-user-modal-header'}>
                                <h2>Invite User</h2>
                            </header>
                            <div style={{minHeight: 210}} className={'edit-user-modal-container'}>
                                <div className={'createUserForm'}>
                                    <Input id={'firstName'}
                                           value={this.state.form.firstName.value}
                                           required={true}
                                           elementType={Type.INPUT}
                                           changed={(event) => this.onChange(event, 'firstName')}
                                           classNameProp={'input-full-width margin-input-for-label'}
                                           valid={this.state.form.firstName.valid}
                                           errorMsg={this.state.form.firstName.errorMsg}
                                           wrapperClass={'half-width-float-left'}
                                           label={'First Name'}
                                           elementConfig={{
                                               placeholder: 'First Name',
                                               tabIndex: 1
                                           }}
                                    />
                                    <Input id={'lastName'}
                                           value={this.state.form.lastName.value}
                                           required={true}
                                           elementType={Type.INPUT}
                                           changed={(event) => this.onChange(event, 'lastName')}
                                           classNameProp={'input-full-width margin-input-for-label'}
                                           valid={this.state.form.lastName.valid}
                                           errorMsg={this.state.form.lastName.errorMsg}
                                           wrapperClass={'half-width'}
                                           label={'Last Name'}
                                           elementConfig={{
                                               placeholder: 'Last Name',
                                               tabIndex: 2
                                           }}
                                    />
                                    <Input id={'userName'}
                                           value={this.state.form.userName.value}
                                           elementType={Type.INPUT}
                                           changed={(event) => this.onChange(event, 'userName')}
                                           classNameProp={'input-full-width margin-input-for-label'}
                                           required={true}
                                           valid={this.state.form.userName.valid}
                                           errorMsg={this.state.form.userName.errorMsg}
                                           wrapperClass={'half-width-float-left'}
                                           label={'Username'}
                                           elementConfig={{
                                               placeholder: 'Username',
                                               tabIndex: 3
                                           }}
                                    />
                                    <Input id={'email'}
                                           value={this.state.form.email.value}
                                           required={true}
                                           elementType={Type.INPUT}
                                           changed={(event) => this.onChange(event, 'email')}
                                           classNameProp={'input-full-width margin-input-for-label'}
                                           valid={this.state.form.email.valid}
                                           errorMsg={this.state.form.email.errorMsg}
                                           wrapperClass={'half-width'}
                                           label={'Email'}
                                           elementConfig={{
                                               placeholder: 'Email',
                                               tabIndex: 4
                                           }}
                                    />
                                </div>
                            </div>
                            <footer style={{
                                background: "#2D3436",
                                borderTop: "2px solid #f5f5f5a3",
                                height: 49,
                                width: "100%",
                                paddingRight: 5,
                                paddingTop: 3,
                            }}>
                                <button
                                    onClick={this.inviteUserHandler}
                                    className={"btn"}
                                    id={"btn-invite"}
                                    style={{float: "right", marginTop: 3, marginLeft: 4}}>
                                    <i className="fas fa-share"> Invite</i>
                                </button>
                                <button
                                    onClick={this.close}
                                    className={"btn"}
                                    style={{float: "right", marginTop: 3, marginRight: 2}}>
                                    <i className="fas fa-times"> Close</i>
                                </button>
                            </footer>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default InviteUserModal


// WEBPACK FOOTER //
// ./app/components/bo-core/grids/UsersGrid/components/inviteUserModal/InviteUserModal.tsx